import axios from 'axios'
import { action, makeAutoObservable, runInAction } from 'mobx'
import { signicatTheme } from '../constants/signicat.theme'

interface StepInterface {
  order: number
  completed: boolean
}

export class AppStateStore {
  rootStore
  isAuthorized = false
  initialAuthCheck = false
  theme: any = signicatTheme
  pageWidth: number = 0
  pageHeight: number = 0
  userFullName: string = 'Igor Kaliciński'
  userFirstName: string = 'Igor'
  userLastName: string = 'K'
  activeCard: string = ''

  firstName: string = ''
  lastName: string = ''
  dateOfBirth: string = ''
  email: string = ''
  phoneNumber: string = ''

  emailValid = false

  constructor(rootStore) {
    makeAutoObservable(this)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.rootStore = rootStore
  }

  @action.bound setIsAuthorized(auth: boolean): void {
    this.isAuthorized = auth
  }

  @action.bound setTheme(theme): void {
    this.theme = theme
  }

  @action.bound setPageWidth(width: number): void {
    this.pageWidth = width
  }

  @action.bound setPageHeight(height: number): void {
    this.pageHeight = height
  }

  @action
  async checkLogin() {
    try {
      runInAction(() => {
        this.initialAuthCheck = true
        this.isAuthorized = true
        this.rootStore.Router.setLocation(window.location.pathname.substring(1))
      })
    } catch (e) {
      runInAction(() => {
        this.initialAuthCheck = true
        this.isAuthorized = false // set to "true" to skip authorization for local development
        this.rootStore.Router.setLocation(window.location.pathname.substring(1))
      })
      console.log(e)
    }
  }

  @action.bound setActiveCard(id: string): void {
    this.activeCard = id
  }

  @action.bound setFirstName(firstName: string): void {
    this.firstName = firstName
  }

  @action.bound setLastName(lastName: string): void {
    this.lastName = lastName
  }

  @action.bound setDateOfBirth(dateOfBirth: string): void {
    this.dateOfBirth = dateOfBirth
  }

  @action.bound setEmail(email: string): void {
    this.email = email

    this.emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  @action.bound setPhoneNumber(phoneNumber: string): void {
    if (!/^[0-9+]*$/.test(phoneNumber)) return

    this.phoneNumber = phoneNumber
  }
}
